/** ISO 3166-1 alpha-2 codes commonly used for client testimonials in LATAM + US/ES. */
export const TESTIMONIAL_COUNTRY_CODES = [
  'PY', 'BO', 'PE', 'CO', 'AR', 'CL', 'UY', 'BR', 'EC', 'VE', 'MX', 'CR', 'PA', 'US', 'ES'
];

/**
 * Converts a two-letter country code to a regional indicator flag emoji (e.g. PE → 🇵🇪).
 */
export function countryCodeToFlagEmoji(code) {
  const normalized = String(code || '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return '';
  return String.fromCodePoint(
    ...normalized.split('').map((char) => 0x1f1e6 + char.charCodeAt(0) - 65)
  );
}

export function normalizeCountryCode(code, fallback = 'PY') {
  const normalized = String(code || '').trim().toUpperCase();
  return /^[A-Z]{2}$/.test(normalized) ? normalized : fallback;
}
